import { ABILITY_PANEL, EVENT_WINDOW, LEADERBOARD, UPGRADE_DOCK } from '../../game/constants/hud';

export const FIRE_BUTTON_PX = 88;
export const ABILITY_BUTTON_PX = 72;

const EDGE_GAP_PX = 16;

const HUD_BOTTOM_BAND_UI = Math.max(
  -(UPGRADE_DOCK.originYFromBottom + UPGRADE_DOCK.liftedYOffset),
  -Math.min(ABILITY_PANEL.bar.yFromBottom, ABILITY_PANEL.drones.yFromBottom),
);

const HUD_TOP_BAND_UI = Math.max(
  LEADERBOARD.rank.y + LEADERBOARD.rank.font,
  EVENT_WINDOW.countdownY,
);

export interface TouchButtonRect {
  readonly right: number;
  readonly bottom: number;
  readonly size: number;
}

export interface TouchLayout {
  readonly fire: TouchButtonRect;
  readonly ability: TouchButtonRect;
  readonly hudBandCss: number;
}

/** Ability stacks above fire where there is height and slides left where there is not — stacking would hit the scoreboard on a short landscape, sliding hits the chat column in portrait. */
export function touchLayout(cssWidth: number, cssHeight: number, cssScale: number): TouchLayout {
  const band = HUD_BOTTOM_BAND_UI * cssScale;
  const fireBottom = band + EDGE_GAP_PX;
  const separation = (FIRE_BUTTON_PX + ABILITY_BUTTON_PX) / 2 + EDGE_GAP_PX;

  const ceiling = cssHeight - HUD_TOP_BAND_UI * cssScale - EDGE_GAP_PX / 2;
  const stackedBottom = fireBottom + FIRE_BUTTON_PX + EDGE_GAP_PX * 0.75;

  let abilityRight = EDGE_GAP_PX;
  let abilityBottom = stackedBottom;

  if (stackedBottom + ABILITY_BUTTON_PX > ceiling) {
    abilityBottom = Math.max(fireBottom, ceiling - ABILITY_BUTTON_PX);
    const dy = abilityBottom + ABILITY_BUTTON_PX / 2 - (fireBottom + FIRE_BUTTON_PX / 2);
    const dx = Math.sqrt(Math.max(0, separation * separation - dy * dy));
    abilityRight = Math.min(
      EDGE_GAP_PX + FIRE_BUTTON_PX / 2 + dx - ABILITY_BUTTON_PX / 2,
      Math.max(EDGE_GAP_PX, cssWidth / 2 - ABILITY_BUTTON_PX),
    );
  }

  return {
    fire: { right: EDGE_GAP_PX, bottom: fireBottom, size: FIRE_BUTTON_PX },
    ability: { right: abilityRight, bottom: abilityBottom, size: ABILITY_BUTTON_PX },
    hudBandCss: band,
  };
}
